import { MyLink } from '@app/shared';
import { TitleBlock } from '@app/widgets/ui/Product/WrapperTabs/ui';
import { useAppSelector } from '@redux/hooks';
import { getListPayment } from '../../module/selectors/getListPayment';
import styles from './PaymentLinks.module.scss';

export const PaymentLinks = () => {
  const list = useAppSelector(getListPayment);

  if (list.length === 0) {
    return null;
  }
  return (
    <div className={styles.Wrapper}>
      <TitleBlock>Как оплатить</TitleBlock>
      <ul className={styles.Container}>
        {list.map(item => {
          return (
            <li key={item.href}>
              <MyLink href={item.href}>{item.name}</MyLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
